module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "hello-page-wrapper video-player-wrapper bodyfont-unauth"
  }, [(_vm.toggleSpinner) ? _c('spinner', {
    staticClass: "pink",
    attrs: {
      "size": "lg",
      "fixed": "",
      "text": "refreshing event"
    },
    model: {
      value: (_vm.toggleSpinner),
      callback: function($$v) {
        _vm.toggleSpinner = $$v
      },
      expression: "toggleSpinner"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.mainLiveEvent && _vm.showRulesComp && _vm.showJoin(_vm.mainLiveEvent)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.showRulesComp) ? _c('rulescomp', {
    style: ({
      border: '1px solid ' + _vm.getCorpHeaderColor
    }),
    attrs: {
      "data": _vm.mainLiveEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), (_vm.mainLiveEvent && _vm.currentVideo) ? _c('div', {
    staticClass: "container-fluid"
  }, [_c('br'), _vm._v(" "), _c('div', {
    staticClass: "video-player autoheight"
  }, [_c('div', {
    staticClass: "left-video-icons"
  }), _vm._v(" "), (_vm.currentVideo) ? _c('div', {
    staticClass: "reset-video-width"
  }, [_c('h2', {
    staticClass: "text-left"
  }, [_vm._v(_vm._s(_vm.mainLiveEvent.title))]), _vm._v(" "), _c('jwplayer', {
    attrs: {
      "id": "mainVideoPlayer",
      "data": _vm.currentVideo
    }
  }, [_vm._v("Loading the player...")])], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "clearfix"
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "player-content"
  }, [(_vm.mainLiveEvent) ? _c('p', {
    staticClass: "video-description"
  }, [_vm._v("\n                            " + _vm._s(_vm.mainLiveEvent.longDescription) + "\n                        ")]) : _vm._e(), _vm._v(" "), (_vm.mainLiveEvent && !_vm.showJoin(_vm.mainLiveEvent)) ? _c('div', {
    staticStyle: {
      "float": "left"
    }
  }, [_c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.mainLiveEvent.title)
      }
    }
  }, [_vm._v("\n                            Add to Calendar\n                            "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.mainLiveEvent.start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.mainLiveEvent.end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.mainLiveEvent.title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.mainLiveEvent.longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.mainLiveEvent.eventId))])])]) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor === '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor"
          })]), _vm._v(" "), _c('network', {
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor"
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor"
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e(), _vm._v(" "), (_vm.getCorpButtonColor !== '#f0617d') ? _c('div', {
    staticClass: "container-icons vpage"
  }, [_c('social-sharing', {
    attrs: {
      "url": _vm.videoURL,
      "media": _vm.videoURL,
      "quote": 'TONE Networks | Expert Advice on Demand',
      "description": _vm.currentVideo.Description,
      "title": _vm.currentVideo.title
    },
    inlineTemplate: {
      render: function() {
        var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
          return _c('div', [_c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "facebook"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-facebook cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "twitter"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-twitter cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "linkedin"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-linkedin cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })]), _vm._v(" "), _c('network', {
            staticClass: "holder",
            style: ({
              backgroundColor: '#A9A9A9 !important'
            }),
            attrs: {
              "network": "email"
            }
          }, [_c('i', {
            staticClass: "fa fa-2x fa-envelope cursor",
            style: ({
              color: '#FFFFFF !important'
            })
          })])], 1)
        
      },
      staticRenderFns: []
    }
  })], 1) : _vm._e()])]), _vm._v(" "), (_vm.mainLiveEvent && _vm.showRulesComp && !_vm.showJoin(_vm.mainLiveEvent)) ? _c('div', {
    staticClass: "col-md-12 pinkbordercomp"
  }, [(_vm.showRulesComp) ? _c('rulescomp', {
    style: ({
      borderWidth: '1px !important',
      borderStyle: 'solid !important',
      borderColor: this.getCorpButtonColor + ' !important'
    }),
    attrs: {
      "data": _vm.mainLiveEvent
    }
  }, [_vm._v("Loading event rules")]) : _vm._e()], 1) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), (_vm.toneLiveHeading) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.toneLiveHeading)
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "container"
  }, [(_vm.allLiveEvents) ? _c('div', {
    staticClass: "row morevediosrow"
  }, [(_vm.allLiveEvents[0]) ? _c('div', {
    staticClass: "col-sm-6"
  }, [_c('a', {
    attrs: {
      "href": '/newevents/' + _vm.allLiveEvents[0].eventId,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.allLiveEvents[0].img_url,
      "alt": _vm.allLiveEvents[0].title,
      "title": _vm.allLiveEvents[0].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title cursor"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[0].title))])]), _vm._v(" "), (_vm.allLiveEvents[0]) ? _c('div', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.allLiveEvents[0].title)
      }
    }
  }, [_vm._v("\n                                Add to Calendar\n                                "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[0].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[0].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[0].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[0].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.allLiveEvents[0].eventId))])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.allLiveEvents[1]) ? _c('div', {
    staticClass: "col-sm-6",
    on: {
      "click": function($event) {}
    }
  }, [_c('a', {
    attrs: {
      "href": '/newevents/' + _vm.allLiveEvents[1].eventId,
      "target": "_blank",
      "rel": "opener"
    }
  }, [_c('img', {
    staticClass: "jw-img",
    attrs: {
      "src": _vm.allLiveEvents[1].img_url,
      "alt": _vm.allLiveEvents[1].title,
      "title": _vm.allLiveEvents[1].title
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "text-wrap-title cursor",
    on: {
      "click": function($event) {}
    }
  }, [_vm._v(_vm._s(_vm.allLiveEvents[1].title))])]), _vm._v(" "), (_vm.allLiveEvents[1]) ? _c('div', {
    staticStyle: {
      "float": "left",
      "margin-bottom": "5px"
    }
  }, [_c('div', {
    staticClass: "addeventatc pinkoutlinebtn",
    style: ({
      color: _vm.getCorpButtonColor + ' !important',
      border: '1px solid ' + _vm.getCorpButtonColor
    }),
    attrs: {
      "title": "Add to Calendar"
    },
    on: {
      "click": function($event) {
        return _vm.calendarLogging($event, _vm.allLiveEvents[1].title)
      }
    }
  }, [_vm._v("\n                               Add to Calendar\n                               "), _c('span', {
    staticClass: "start"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[1].start_date))]), _vm._v(" "), _c('span', {
    staticClass: "end"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[1].end_date))]), _vm._v(" "), _c('span', {
    staticClass: "timezone"
  }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[1].title))]), _vm._v(" "), _c('span', {
    staticClass: "description"
  }, [_vm._v(_vm._s(_vm.allLiveEvents[1].longDescription))]), _vm._v(" "), _c('span', {
    staticClass: "location"
  }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(_vm.allLiveEvents[1].eventId))])])]) : _vm._e()]) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "gap clearfix"
  }), _vm._v(" "), _c('div', {
    staticClass: "sliderTalkBox"
  }, [(_vm.toneTalkHeading) ? _c('h2', {
    domProps: {
      "innerHTML": _vm._s(_vm.toneTalkHeading)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.toneTalkDesc) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.toneTalkDesc)
    }
  }) : _vm._e(), _vm._v(" "), (_vm.allTalkEvents) ? _c('div', {
    staticClass: "slider responsive-slick-slider"
  }, _vm._l((_vm.allTalkEvents), function(talkEvent) {
    return _c('div', {
      staticClass: "col-sm-4"
    }, [_c('a', {
      attrs: {
        "href": '/event/' + talkEvent.eventId,
        "target": "_blank",
        "rel": "opener"
      }
    }, [_c('h2', {
      staticStyle: {
        "color": "#5E5E5E"
      }
    }, [_vm._v(_vm._s(_vm.getDateReference(talkEvent.start_date, 'live')) + ": " + _vm._s(talkEvent.title))])]), _vm._v(" "), _c('p', [_vm._v("\n                                " + _vm._s(talkEvent.longDescription) + "\n                            ")]), _vm._v(" "), _c('h5', [_vm._v(_vm._s(_vm.getDateReference(talkEvent.start_date, 'live2')))]), _vm._v(" "), _c('div', {
      staticClass: "addeventatc pinkoutlinebtn",
      style: ({
        color: _vm.getCorpButtonColor + ' !important',
        border: '1px solid ' + _vm.getCorpButtonColor
      }),
      attrs: {
        "title": "Add to Calendar"
      },
      on: {
        "click": function($event) {
          return _vm.calendarLogging($event, talkEvent.title)
        }
      }
    }, [_vm._v("\n                                Add to Calendar\n                                "), _c('span', {
      staticClass: "start"
    }, [_vm._v(_vm._s(talkEvent.start_date))]), _vm._v(" "), _c('span', {
      staticClass: "end"
    }, [_vm._v(_vm._s(talkEvent.end_date))]), _vm._v(" "), _c('span', {
      staticClass: "timezone"
    }, [_vm._v("America/New_York")]), _vm._v(" "), _c('span', {
      staticClass: "title"
    }, [_vm._v(_vm._s(talkEvent.title))]), _vm._v(" "), _c('span', {
      staticClass: "description"
    }, [_vm._v(_vm._s(talkEvent.longDescription))]), _vm._v(" "), _c('span', {
      staticClass: "location"
    }, [_vm._v(_vm._s(_vm.eventURL) + "/event/" + _vm._s(talkEvent.eventId))])])])
  }), 0) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "text-center"
  }, [(!_vm.getCorporateGiftingCode) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.$router.push('/signup')
      }
    }
  }, [_vm._v("Start Your Free Trial")]) : _vm._e(), _vm._v(" "), (_vm.getCorporateGiftingCode && _vm.getCorporateClient) ? _c('button', {
    staticClass: "btn btn-success btn-lg",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.redeemCode()
      }
    }
  }, [_vm._v(_vm._s(_vm.getCorporateGiftInfo.button_label_01))]) : _vm._e()])])])], 1)
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-0f63bdda", module.exports)
  }
}


// WEBPACK FOOTER //
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f63bdda"}!./~/vue-loader/lib/selector.js?type=template&index=0!./~/string-replace-loader?{"search":"pk_test_6pRNASCoBOKtIshFeQd4XMUh","replace":"pk_test_SLHUyTkZmNS1OnLNdclgNldo"}!./~/string-replace-loader?{"search":"https:/www1.dev-tonenetworks.com","replace":"https:/www1.dev-tonenetworks.com"}!./~/string-replace-loader?{"search":"https:/s3.amazonaws.com/tone-assets/app/navigation","replace":"https:/s3.amazonaws.com/tone-assets/app/navigation"}!./~/string-replace-loader?{"search":"sandbox_2yn8x45w_k2v4j3d55x4gh6xz","replace":"production_6r7mxqgh_htw3nq9wp32w8h2x"}!./src/components/NewEvents.vue